import React, {Fragment} from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter as Router, Routes, Route, useParams, useLocation, Link, Navigate } from "react-router-dom";
import { useLayoutEffect } from 'react'

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CookieConsent from "react-cookie-consent";
import i18n from "./config/i18n";


import Box from '@mui/material/Box';


import Start from "./pages/Start";
import Immobilienverwaltung from "./pages/Immobilienverwaltung";
import Immobilienbewertung from "./pages/Immobilienbewertung";
import Immobilienverkauf from "./pages/Immobilienverkauf";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";


import NotFound from "./pages/NotFound";
import SpeedAccess from './snippets/SpeedAccess';

import Footer from "./pages/Footer";

import './App.css';



const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

const Wrapper = ({children}) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
} 

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}


const Protected = ({ isAuthenticated, changeAuth, component: Component, ...routeProps }) => {

	if (isAuthenticated === false) {
    	return <Navigate  to="/login" />;
  	}

  	return (
    	<Fragment>
       		<Component changeAuth={changeAuth} {...routeProps} />
    	</Fragment>
  	);

};



export default function App() {
 	const [mode, setMode] = React.useState('light');
 	const [size, setSize] = React.useState(12);
 	const [theme, setTheme] = React.useState("themeDefault");


		
  	const themeDefault = React.useMemo(
	    () =>
	      createTheme({
			palette: {
			    primary: {
			      main: '#163e64',
			      light: '#1a4e80',
			      dark: '#0f2a44',
			      contrastText: '#fff',
			    },
			  },			  
	        typography: {
				fontSize: size,
				fontFamily: "'LatoRegular'"
			},
	      }),
	    [mode],
  	); 
	const colorMode = React.useMemo(
	    () => ({
	      toggleColorMode: () => {
	        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
	      },
	    }),
	    [],
	);	
	
	
  	return (
			<CookiesProvider defaultSetOptions={{ path: '/' }}>
			    <ColorModeContext.Provider value={colorMode}>  	
					<ThemeProvider theme={themeDefault}>
			  			<Router>
			  				<Inner />
    					</Router>
					    <CookieConsent
					        location="bottom"
					        enableDeclineButton
					        buttonText="akzeptieren"
					        declineButtonText="verbieten"
					        cookieName="SabineKarst"
					        style={{ background: "#3ea447" }}
					        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
					        expires={150}
					      >
					      Diese Webseite verwendet Cookies. {" "}
					      <span style={{ fontSize: "10px" }}><br/>Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren und die Zugriffe auf unsere Website zu analysieren.</span>
					 	</CookieConsent>			  			
					</ThemeProvider>
				</ColorModeContext.Provider>
			</CookiesProvider>				
    					
  );
}



function Inner() {
	let query = useQuery();
	const [language, setLanguage] = React.useState(query.get("lng") ?  query.get("lng") : "de");
	const [isAuthenticated, setIsAuthenticated] = React.useState(false);
	i18n.changeLanguage(language);


	const FrontendFooter = () => {
  		return 	<Box>
					<SpeedAccess />
					<Footer/>
																		  				
				</Box>;
	};

  	return (	<Wrapper>
					<Routes>
			  			<Route exact path="/" element={<>
			  										<Start /> 
													<FrontendFooter />
			  									</>} />
			  			<Route exact path="/immobilienverwaltung" element={<>
			  										<Immobilienverwaltung /> 
													<FrontendFooter />
			  									</>} />
			  			<Route exact path="/immobilienbewertung" element={<>
			  										<Immobilienbewertung /> 
													<FrontendFooter />
			  									</>} />
			  			<Route exact path="/immobilienverkauf" element={<>
			  										<Immobilienverkauf /> 
													<FrontendFooter />
			  									</>} />
			  			<Route exact path="/impressum" element={<>
			  										<Impressum /> 
													<FrontendFooter />
			  									</>} />
			  			<Route exact path="/datenschutz" element={<>
			  										<Datenschutz /> 
													<FrontendFooter />
			  									</>} />

			  			<Route path="*" element={<>
	  												<NotFound  />
	  												<FrontendFooter/>
			  									</>} 
			  			/>
			        </Routes>
		        </Wrapper>
  	);
}

